// eslint-disable-next-line max-len
var MISC_FLAG_SCANDINAVIA = 'M31,5.5H.05v7H0v2H.05v3H0v2H.05v7H32V5.5Zm-1,7H15v-5H30ZM2,7.5H8v5H2Zm0,7h8v-7h3v7H30v3H13v7H10v-7H2Zm0,5H8v5H2Zm13,5v-5H30v5Z';

export { MISC_FLAG_SCANDINAVIA };
//# sourceMappingURL=MISC_FLAG_SCANDINAVIA.js.map
